import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { KilnK, KilnText } from './Icons';

const Login = (props) => {
    const { loginWithRedirect } = useAuth0();
    const theme = useTheme();

    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20vh',
            backgroundColor: theme.palette.background.main
        }}>
            <Box boxShadow={12} sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 3,
                background: theme.palette.background.paper,
                borderRadius: theme.shape.borderRadius
            }}>
                <Box sx={{
                    width: '300px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    marginBottom: theme.spacing(2),
                    gap: theme.spacing(2)
                }}>
                    <Box sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        color: theme.palette.secondary.main 
                    }}>
                        <KilnK />
                    </Box>
                    <KilnText/>
                </Box>
                <Typography variant='body1' color={theme.palette.text.secondary} gutterBottom>
                    Login Required to Access This Page
                </Typography>
                <Button onClick={() => loginWithRedirect()} sx={{
                    marginTop: 3
                }}>
                    Login
                </Button>
            </Box>
        </Box>
    );
};

export default Login;